import { featureCards } from '@/mocks/siteContent';

export default function FeatureCards() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
            Why Use Sugargoo Spreadsheet?
          </h2>
          <p className="mt-3 text-foreground-500 max-w-2xl mx-auto text-sm md:text-base">
            Finding the right Sugargoo products shouldn&apos;t be a struggle. Our organized spreadsheet resources make shopping faster, easier, and more enjoyable.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featureCards.map((card) => (
            <div
              key={card.title}
              className="bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 transition-colors group"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-100 mb-4">
                <i className={`${card.icon} text-primary-600 text-lg`}></i>
              </span>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{card.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}